import { useState } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);
    const hpVal = (formData.get('phone_alt') as string || '').trim();
    if (hpVal) {
      setStatus('success');
      setEmail('');
      return;
    }
    setStatus('loading');
    try {
      const res = await fetch('http://vktest.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '';
        if (serverMsg.includes('spam')) {
          setErrorMsg('提交失败，请稍后再试。');
        } else {
          setErrorMsg(serverMsg || '提交失败，请稍后再试。');
        }
        setStatus('error');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查连接后重试。');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
          加入韩漫社区
        </h2>
        <p className="text-foreground-500 text-sm md:text-base mb-8 max-w-lg mx-auto">
          订阅我们的推送，第一时间获取最新韩漫更新、独家推荐和限时活动信息。
        </p>

        <form
          onSubmit={handleSubmit}
         
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto mb-10"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入您的邮箱地址"
            required
            className="w-full sm:flex-1 px-5 py-3 rounded-full bg-background-100 border border-background-300 text-foreground-900 text-sm outline-none focus:border-primary-400 transition-colors placeholder:text-foreground-400"
          />
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="hp-field"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap cursor-pointer"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
            <i className="ri-arrow-right-line ml-1.5"></i>
          </button>
        </form>

        {status === 'success' && (
          <p className="text-secondary-600 text-sm">订阅成功！感谢您加入韩漫社区。</p>
        )}
        {status === 'error' && (
          <p className="text-accent-600 text-sm">{errorMsg}</p>
        )}

        <div className="mt-6 relative h-16 overflow-hidden">
          <div className="flex items-center justify-center gap-4 md:gap-8">
            <div className="w-12 h-16 md:w-14 md:h-20 rounded-lg bg-background-200 overflow-hidden flex-shrink-0">
              <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20book%20spine%20minimalist%20design%20pastel%20pink%20abstract%20graphic%20clean%20simple%20geometric%20flat%20illustration&width=120&height=168&seq=cta-spine-1&orientation=portrait" alt="" className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="w-12 h-16 md:w-14 md:h-20 rounded-lg bg-background-200 overflow-hidden flex-shrink-0">
              <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20book%20spine%20minimalist%20design%20mint%20green%20abstract%20graphic%20clean%20simple%20flat%20illustration&width=120&height=168&seq=cta-spine-2&orientation=portrait" alt="" className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="w-12 h-16 md:w-14 md:h-20 rounded-lg bg-background-200 overflow-hidden flex-shrink-0">
              <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20book%20spine%20minimalist%20design%20warm%20beige%20abstract%20graphic%20clean%20simple%20flat%20illustration&width=120&height=168&seq=cta-spine-3&orientation=portrait" alt="" className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="hidden sm:block w-12 h-16 md:w-14 md:h-20 rounded-lg bg-background-200 overflow-hidden flex-shrink-0">
              <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20book%20spine%20minimalist%20design%20coral%20orange%20abstract%20graphic%20clean%20simple%20flat%20illustration&width=120&height=168&seq=cta-spine-4&orientation=portrait" alt="" className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="hidden md:block w-12 h-16 md:w-14 md:h-20 rounded-lg bg-background-200 overflow-hidden flex-shrink-0">
              <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20book%20spine%20minimalist%20design%20soft%20lavender%20abstract%20graphic%20clean%20simple%20flat%20illustration&width=120&height=168&seq=cta-spine-5&orientation=portrait" alt="" className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="hidden md:block w-12 h-16 md:w-14 md:h-20 rounded-lg bg-background-200 overflow-hidden flex-shrink-0">
              <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20book%20spine%20minimalist%20design%20warm%20golden%20abstract%20graphic%20clean%20simple%20flat%20illustration&width=120&height=168&seq=cta-spine-6&orientation=portrait" alt="" className="w-full h-full object-cover" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}